const Tawk = {};
Tawk.install = function (Vue, options) {
  Vue.prototype.$Tawk = {};
  Vue.prototype.$Tawk.$createChat = function (tawkSrc = null) {
    Tawk.tawkSrc = tawkSrc === null ? options.tawkSrc : tawkSrc;
    if (Tawk.tawkSrc !== undefined) {
      const Tawk_API = {};
      const Tawk_LoadStart = new Date();
      const s1 = document.createElement('script');
      const s0 = document.getElementsByTagName('script')[0];
      s1.async = true;
      s1.src = Tawk.tawkSrc;
      s1.charset = 'UTF-8';
      s1.setAttribute('crossorigin', '*');
      s0.parentNode.insertBefore(s1, s0);
      window.Tawk_API = Tawk_API;
    }
  };
  Vue.prototype.$Tawk.$createChat(Tawk.tawkSrc);
  Vue.prototype.$Tawk.$updateChatUser = function (user) {
    if (!user) return;
    window.Tawk_API.onLoad = function () {
      window.Tawk_API.setAttributes({
        name: user.name,
        email: user.email,
        hash: user.emailHmac,
      }, (error) => {
        console.log(error);
      });
    };
  };
  Vue.prototype.$Tawk.$endChat = function () {
    window.Tawk_API.endChat();
  };
  Vue.prototype.$Tawk.$isInit = function () {
    return !!window.Tawk_API;
  };
};
export default Tawk;
